import { Text, View } from "@react-pdf/renderer";
import dayjs from "dayjs";
import { MONTH_DAY_YEAR_TIME_AMPM_FORMAT } from "src/constants";
import styles from "./styles";

interface IProps {
    timezone: string;
    // Only if chart is being finalized should we pass this in
    signatureText?: string;
}

const PDFFooter: React.FC<IProps> = ({ timezone, signatureText }) => {
    return (
        <View id="pdf-footer" style={[styles.w100, styles.footer]} fixed>
            <Text style={[styles.textMs, styles.textMed, styles.mr12]}>
                {`${signatureText ? "Signed by " + signatureText : "Generated"} on ${dayjs().tz(timezone).format(MONTH_DAY_YEAR_TIME_AMPM_FORMAT)}`}
            </Text>

            <Text
                style={[styles.textMs, styles.textMed]}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            />
        </View>
    );
};

export default PDFFooter;
